/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputTotpSecretResponse
 */
export interface OutputTotpSecretResponse {
    /**
     * Base64 encoded QR code image
     * @type {string}
     * @memberof OutputTotpSecretResponse
     */
    qrCode?: string;
    /**
     * Base32 encoded secret
     * @type {string}
     * @memberof OutputTotpSecretResponse
     */
    secret?: string;
}

/**
 * Check if a given object implements the OutputTotpSecretResponse interface.
 */
export function instanceOfOutputTotpSecretResponse(value: object): boolean {
    return true;
}

export function OutputTotpSecretResponseFromJSON(json: any): OutputTotpSecretResponse {
    return OutputTotpSecretResponseFromJSONTyped(json, false);
}

export function OutputTotpSecretResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputTotpSecretResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'qrCode': json['qrCode'] == null ? undefined : json['qrCode'],
        'secret': json['secret'] == null ? undefined : json['secret'],
    };
}

export function OutputTotpSecretResponseToJSON(value?: OutputTotpSecretResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'qrCode': value['qrCode'],
        'secret': value['secret'],
    };
}

